import { fetch } from '@/utils/http'

export default {
  //用户
  addUser: params => fetch('post', '/cbaas-service/v1/user/add', params),
  getUserList: params => fetch('get', '/cbaas-service/v1/user/list', params),
  resetPwd: params => fetch('post', '/cbaas-service/v1/user/passwd/reset', params),
  changePwd: params => fetch('post', '/cbaas-service/v1/user/passwd/change', params),
  reviseUser: params => fetch('post', '/cbaas-service/v1/user/modify', params),
  deleteUser: params => fetch('post', '/cbaas-service/v1/user/del', params),
  getCert: params => fetch('get', '/cbaas-service/v1/user/cert/list', params),
  mapCert: params => fetch('post', '/cbaas-service/v1/user/cert/bind', params),
  getUserInfo: params => fetch('get', '/cbaas-service/v1/user/info', params),
  //角色
  getRoleList: params => fetch('get', '/cbaas-service/v1/auth/queryRoleList', params),
  reviseRole: params => fetch('put', '/cbaas-service/v1/auth/updateRole', params),
  createRole: params => fetch('post', '/cbaas-service/v1/auth/createRole', params),
  getRoleAuth: params => fetch('get', '/cbaas-service/v1/auth/moduleList', params),
  reviseRoleAuth: params => fetch('put', '/cbaas-service/v1/auth/updateRoleModule', params)
}
